
if (window.innerWidth < 481) {

  setTimeout(() => {
    document.querySelectorAll(".variant-picker__option-info").forEach(el => {
      el.addEventListener(
        "click",
        function (e) {
          e.stopImmediatePropagation();

          const content =
            this.parentElement.querySelector(".variant-picker__option-content") ||
            this.parentElement.querySelector(".relative");

          const arrow = this.querySelector("svg");
          const open = this.getAttribute("state") === "open";

          if (open) {
            content.style.display = "none";
            this.setAttribute("state", "close");

            if (arrow) {
              arrow.style.transform = "rotate(180deg)";
            }
          } else {
            content.style.display = "block";
            this.setAttribute("state", "open");

            if (arrow) {
              arrow.style.transform = "none";
            }
          }
        },
        true
      );
    });
  }, 2000);

}
